import { UpdateEntrepreneurFormValues } from "src/core/forms/stakeholder/updateEntrepreneur.schema";
import { UpdateStakeholderFullFormValues } from "src/core/forms/stakeholder/updateStakeholderFull.schema";
import { Document } from "src/core/types/document";
import { FolderEntrepriseFormValues } from "src/core/types/folder";
import { isEmpty } from "src/core/utils/form";

export const isDocumentIncomplete = (doc: Document) => {
  return (
    doc.file === null && !doc.existing && doc.fileId === undefined && doc.fileName === undefined
  );
};

/**
 * Liste les champs incomplets pour le formulaire Entreprise.
 */
export const computeCorporationIncompleteFields = (values: FolderEntrepriseFormValues) => {
  const incompleteFields = new Set<string>();

  for (const [key, value] of Object.entries(values)) {
    switch (key) {
      case "formeJuridiquePrecision":
        // Cas particulier : le champ "Préciser la forme juridique" est requis si la forme juridique est "other"
        if (values.formeJuridique === "other" && isEmpty(value as string)) {
          incompleteFields.add(key);
          break;
        }
        break;
      case "documents":
        Object.entries(value).forEach(([docKey, doc]: [string, Document]) => {
          if (isDocumentIncomplete(doc)) {
            incompleteFields.add(docKey);
          }
        });
        break;
      default:
        if (typeof value === "string" && isEmpty(value)) {
          incompleteFields.add(key);
          break;
        }
        break;
    }
  }

  return incompleteFields;
};

export const computeStakeholderIncompleteFields = (
  values: UpdateStakeholderFullFormValues | UpdateEntrepreneurFormValues
) => {
  const incompleteFields = new Set<string>();

  for (const [key, value] of Object.entries(values)) {
    switch (key) {
      case "documents":
        Object.entries(value).forEach(([docKey, doc]: [string, Document]) => {
          if (isDocumentIncomplete(doc)) {
            incompleteFields.add(docKey);
          }
        });
        break;
      default:
        if (typeof value === "string" && isEmpty(value)) {
          incompleteFields.add(key);
          break;
        }
        break;
    }
  }

  return incompleteFields;
};
